export var BusinessType;
(function (BusinessType) {
    BusinessType["Deposit"] = "Deposit";
    BusinessType["Withdraw"] = "Withdraw";
    BusinessType["Transfer"] = "Transfer";
})(BusinessType || (BusinessType = {}));
export var AuthTokenSource;
(function (AuthTokenSource) {
    AuthTokenSource["Portkey"] = "portkey";
    AuthTokenSource["NightElf"] = "nightElf";
    AuthTokenSource["EVM"] = "EVM";
    AuthTokenSource["Solana"] = "Solana";
    AuthTokenSource["TRON"] = "TRX";
    AuthTokenSource["TON"] = "Ton";
})(AuthTokenSource || (AuthTokenSource = {}));
export var TWalletType;
(function (TWalletType) {
    TWalletType["Portkey"] = "portkey";
    TWalletType["NightElf"] = "nightElf";
})(TWalletType || (TWalletType = {}));
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus["Health"] = "Health";
    NetworkStatus["Congesting"] = "Congesting";
    NetworkStatus["Offline"] = "Offline";
})(NetworkStatus || (NetworkStatus = {}));
export var RecordsRequestType;
(function (RecordsRequestType) {
    RecordsRequestType[RecordsRequestType["All"] = 0] = "All";
    RecordsRequestType[RecordsRequestType["Deposit"] = 1] = "Deposit";
    RecordsRequestType[RecordsRequestType["Withdraw"] = 2] = "Withdraw";
})(RecordsRequestType || (RecordsRequestType = {}));
export var RecordsRequestStatus;
(function (RecordsRequestStatus) {
    RecordsRequestStatus[RecordsRequestStatus["All"] = 0] = "All";
    RecordsRequestStatus[RecordsRequestStatus["Processing"] = 1] = "Processing";
    RecordsRequestStatus[RecordsRequestStatus["Succeed"] = 2] = "Succeed";
    RecordsRequestStatus[RecordsRequestStatus["Failed"] = 3] = "Failed";
})(RecordsRequestStatus || (RecordsRequestStatus = {}));
export var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["Processing"] = "Processing";
    OrderStatusEnum["Succeed"] = "Succeed";
    OrderStatusEnum["Failed"] = "Failed";
})(OrderStatusEnum || (OrderStatusEnum = {}));
export var WalletSourceType;
(function (WalletSourceType) {
    WalletSourceType["EVM"] = "EVM";
    WalletSourceType["Solana"] = "Solana";
    WalletSourceType["TRX"] = "TRX";
    WalletSourceType["Ton"] = "Ton";
    WalletSourceType["Portkey"] = "Portkey";
})(WalletSourceType || (WalletSourceType = {}));
export var TransactionRecordStep;
(function (TransactionRecordStep) {
    TransactionRecordStep[TransactionRecordStep["Submitted"] = 0] = "Submitted";
    TransactionRecordStep[TransactionRecordStep["FromTransfer"] = 1] = "FromTransfer";
    TransactionRecordStep[TransactionRecordStep["ToTransfer"] = 2] = "ToTransfer";
    TransactionRecordStep[TransactionRecordStep["ReceivedOrSent"] = 3] = "ReceivedOrSent";
})(TransactionRecordStep || (TransactionRecordStep = {}));
export var UpdateTransferOrderStatus;
(function (UpdateTransferOrderStatus) {
    UpdateTransferOrderStatus["Rejected"] = "Rejected";
})(UpdateTransferOrderStatus || (UpdateTransferOrderStatus = {}));
